import Vue from "vue";
import Vuex from "vuex";

import { states } from "./states";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";

Vue.use(Vuex);

// eslint-disable-next-line import/no-named-as-default-member
export default new Vuex.Store({
    state: states,
    mutations: mutations,
    getters: getters,
    actions: actions
});
